import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
var PlIconButtonContainer = function (_a) {
    var children = _a.children, onClick = _a.onClick, disabled = _a.disabled, className = _a.className;
    return (_jsx("button", { onClick: onClick, disabled: disabled, className: "bg-grey-extra-light w-8 h-8 rounded-full flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed ".concat(className), children: children }));
};
export default PlIconButtonContainer;
